<template>
    <VCard
        :class="isFullscreen ? 'q-agency-structure-chart--fullscreen' : ''"
        class="q-agency-structure-chart"
    >
        <v-progress-linear indeterminate v-if="run_q"></v-progress-linear>
        <OrganizationChart
            v-if="agent"
            :pan="true"
            :datasource="items"
        >
          <template #default="{ nodeData }">
            <div>
              <div v-if="nodeData.AgentName === 'Producers'">
                <div v-for="(p, key) in nodeData.producers" :key="key">
                  <div class="q-subtitle">
                    <router-link :to="'/agents/' + p.AgentCode">
                      {{ p.AgentDisplayName }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div v-else>
                <div>
                  <router-link :to="'/agents/' + nodeData.AgentCode">{{ nodeData.AgentDisplayName || nodeData.AgentName }}</router-link>
                </div>
                <v-progress-circular size="20" indeterminate v-if="nodeData.loading"></v-progress-circular>
                <v-btn v-if="nodeData.children.length === 0 && !nodeData.loading" icon small @click="fetchAgents(nodeData)">
                  <v-icon small>fas fa-caret-down</v-icon>
                </v-btn>
                <v-btn v-else-if="!nodeData.loading" icon small @click="closeNode(nodeData)">
                  <v-icon small>fas fa-caret-up</v-icon>
                </v-btn>
              </div>
            </div>
          </template>
        </OrganizationChart>
        <div v-if="!items.loading && hasRole('SuperAdmin')" class="top-left">
            <v-btn @click="expandAllChildren">Load All Branches</v-btn>
            <v-btn icon title="Toggle fullscreen" @click="isFullscreen = !isFullscreen">
                <v-icon>fas fa-expand</v-icon>
            </v-btn>
        </div>
    </VCard>
    <!--<highcharts :options="chartOptions"></highcharts>//-->
    <!--<combo-chart :height="null" :width="null" :chart-data="chartdata" :options="options"></combo-chart>//-->
</template>
<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import OrganizationChart from "@/components/charts/OrganizationChart.vue";
export default {
    name: "QAgencyStructureChart",
    props: ['agent'], // data passed to component from parent
    data: function() { // data internal to component (not available outside)
        return {
            items: {
                AgentName: this.agent?.AgentCode === 'SFG00001' ? 'Symmetry' : this.agent?.AgentName,
                id: this.agent?.AgentCode,
                AgentCode: this.agent?.AgentCode,
                LeadershipLevel: this.agent?.LeadershipLevel,
                downline: [],
                type: 'shop',
                loading: false,
                children: [],
            },
            qu: [],
            run_q: false,
            isFullscreen: false,
        }
    },
    mounted: function() {
        if (this.agent) {
            this.fetchAgents(this.items);
        }

        window.addEventListener('keydown', this.onKeypress, { capture: true })
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.onKeypress, { capture: true })
    },
    computed: {
        bgColor() {
            return this.$vuetify.theme.dark ? 'black' : 'white'
        }
    },
    methods: {
        fetchAgents: function(agent) {
            var g = this
            if (!agent?.AgentCode) {
                return;
            }
            if (typeof agent.cached_children != 'undefined') {
                this.$set(agent, 'children', agent.cached_children);
                return;
            }
            agent.loading = true
            QuilityAPI.getAgentDownline(agent.AgentCode, ['LeadershipLevel'], 'tree-structure', this.hasRole(['AgencyOwner', 'SalesRep']), true).then(function(resp) {
                const children = resp.data.children.filter((agent) => {
                    if (agent.AgentName === 'Producers' && !agent.producers?.length) { return false }
                    return true
                })
                g.$set(agent, 'children', children);
                agent.loading = false
                if (g.loading) {
                    for (var i = 0; i < children.length; i++) {
                        if (children[i].AgentName !== 'Producers') {
                            g.addAgentToQ(children[i]);
                            if (!g.run_q) {
                                g.run_q = true
                                g.runQ();
                            }
                        }
                    }
                }
            });
        },
        closeNode: function(agent) {
            this.$set(agent, 'cached_children', agent.children);
            this.$set(agent, 'children', []);
        },
        runQ() {
            if (!this.run_q) {
                return
            }
            if (this.qu.length > 0) {
                var agent = this.qu.pop();
                var g = this
                setTimeout(function() {
                    g.fetchAgents(agent);
                    g.runQ();
                }, 1000)
            } else {
                this.run_q = false;
            }
        },
        addAgentToQ($agent) {
            this.qu.push($agent)
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        expandAllChildren: function() {
            var g = this
            this.loading = true
            this.run_q = true
            for (var i = 0; i < this.items.children.length; i++) {
                if (this.items.children[i].AgentName !== 'Producers') {
                    this.addAgentToQ(this.items.children[i]);
                }
            }
            this.runQ();
        },
        onKeypress(e) {
            if (e.keyCode === 27) {
                this.isFullscreen = false
            }
        }
    },
    watch: {
        agent (newV) {
            this.items = {
                AgentName: newV?.AgentName,
                id: newV?.AgentCode,
                AgentCode: newV?.AgentCode,
                LeadershipLevel: newV?.LeadershipLevel,
                downline: [],
                type: 'shop',
                loading: false,
                children: []
            }
            this.fetchAgents(this.items);
        }
    },
    components: {
        OrganizationChart,
    },
    beforeRouteLeave(to, from, next) {

    }
}
</script>
<style lang="scss" scoped>
.orgchart-container {
    height: max-content;
    width: 100%;
}

.q-agency-structure-chart {
    position: relative;

    &--fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        z-index: 9999;
        overflow: hidden;
    }

    .orgchart-container {
        min-height: 100vh;
        max-height: 100%;
    }
}

.top-left {
    position: absolute;
    top: 15px;
    right: 15px;
    display: flex;
    gap: 0.5rem;
}
</style>